import { ModalController, LoadingController } from 'ionic-angular';
import { CalculationService } from "../calculation/calculation-service";

// actions
import { Action } from './action/action';
import { ActionRowRepeat } from './action/action-row-repeat';
import { ActionRowMarkGreen } from './action/action-row-mark-green';

export class RowActionService {

    constructor(
        protected calculationService: CalculationService,
        protected modalController: ModalController,
        protected loadingController: LoadingController
    ) {}
    
    triggerAction(action:string, row:any) : Promise<boolean> {
        let actionTrigger:Action = null;

        switch (action) {
            case 'action-row-repeat':
                actionTrigger = new ActionRowRepeat(this.calculationService, this.modalController, this.loadingController);
                break;
            case 'action-row-mark-green':
                actionTrigger = new ActionRowMarkGreen(this.calculationService, this.loadingController);
                break;
        }

        if (actionTrigger) {
            return actionTrigger.trigger(row);
        } else {
            return Promise.reject('no action found');
        }
    }

}


// WEBPACK FOOTER //
// ./src/services/row-action/row-action-service.ts